export default "__VITE_ASSET__4fecee33__"